class StickyAddToCart extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["atc-bar"];
  }

  getStickyHeaderOffset = () => {
    if (!this.externalEls.header.element || !this.hasStickyHeader) {
      return 0;
    }

    return this.externalEls.header.element.offsetHeight;
  };

  connectedCallback() {
    super.connectedCallback();
    this.stickyBarHeight = this.offsetHeight;
    this.style.setProperty("--StickyBar_Height", `${this.stickyBarHeight}px`);

    const headerStyle = getComputedStyle(this.externalEls.header.element);
    this.hasStickyHeader = headerStyle.position === "sticky";

    this.stickyHeaderOffset = this.getStickyHeaderOffset();

    this.createSticky();
  }

  createSticky() {
    const productForm = this.externalEls.form.element;

    if (!productForm) return;

    const footerElement = this.externalEls.footer.element;
    const atcButtonElement =
      productForm.querySelector(".prd-Detail_Buttons") || productForm;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.target === footerElement) {
            this._isFooterVisible = entry.intersectionRatio > 0;
          }
          if (entry.target === atcButtonElement) {
            this.isAtcButtonVisible = entry.intersectionRatio > 0;
          }

          if (!this.isAtcButtonVisible && !this._isFooterVisible) {
            this.stickyBarHeight = this.offsetHeight;

            document.body.style.setProperty(
              "--StickyBar_Height",
              `${this.stickyBarHeight}px`,
            );
            this.classList.add("sty-StickyBar-sticky");
            this.setAttribute("aria-hidden", false);
          } else {
            this.stickyBarHeight = this.offsetHeight;
            document.body.style.setProperty("--StickyBar_Height", 0);
            this.classList.remove("sty-StickyBar-sticky");
            this.setAttribute("aria-hidden", true);
          }
        }
      },
      { rootMargin: `-${this.stickyHeaderOffset}px 0px 0px 0px` },
    );
    observer.observe(atcButtonElement);
    observer.observe(footerElement);
  }
}

if (!customElements.get("sticky-bar")) {
  customElements.define("sticky-bar", StickyAddToCart);
}
